<template>
  <div  class="columns is-multiline is-main-content is-marginless is-paddingless"
        v-if='critereRecherche'>
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('detailsPlanningFaceUnitaire.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('detailsPlanningFaceUnitaire.filtre.sousTitle') }}
        </span>
      </div>
    </div>
        <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
        <div class="columns is-marginless is-multiline">
            <div class="column is-12 pdb-0">
                <b-field :label="$t('detailsPlanningFaceUnitaire.filtre.reference')">
                  <b-input v-model="critereRecherche.reference"></b-input>
                </b-field>
            </div>
            <div class="column is-12 pdb-0">
                <b-field :label="$t('detailsPlanningFaceUnitaire.filtre.ville')">
                  <ville-tag-input-auto-complete
                      :critere-recherche="this.critereRecherche"
                      table-name="Produit"/>
                </b-field>
            </div>
            <div class="column is-12 pdb-0">
                <b-field :label="$t('detailsPlanningFaceUnitaire.filtre.format')">
                  <qd-taginput type='is-primary' v-model="critereRecherche.formats"></qd-taginput>
                </b-field>
            </div>
            <div class="column is-12 pdb-0">
                <b-field :label="$t('detailsPlanningFaceUnitaire.filtre.material')">
                  <qd-taginput type='is-primary' v-model="critereRecherche.materiels"></qd-taginput>
                </b-field>
            </div>
            <div class="column is-12 pdb-0">
                <b-field :label="$t('detailsPlanningFaceUnitaire.filtre.avecReseaux')">
                  <qd-switch v-model="critereRecherche.avecAffectationReseau">
                  </qd-switch>
                </b-field>
            </div>
            <div class="column is-12 pdb-0">
              <b-field :label="$t('detailsPlanningFaceUnitaire.filtre.eclaire')">
                <b-select v-model="critereRecherche.eclaire">
                  <option :value="null"></option>
                  <option :value="true"> {{ $t('general.oui') }}
                  </option>
                  <option :value="false"> {{ $t('general.non') }}
                  </option>
                </b-select>
              </b-field>
            </div>
          <div class="column is-12 pdb-0" v-if="societesInformations.length > 1
          && !filtrerProduitParSociete && !filtrerProduitParAgence">
            <b-field :label="$t('detailsPlanningFaceUnitaire.filtre.societe')">
              <b-select v-model="critereRecherche.societeId" expanded>
                <option :value=null></option>
                <option v-for="societe in societesInformations"
                        :key="societe.id"
                        :value="societe.id">
                  {{ societe.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-12 pdb-0" v-if="moduleSecteurActive">
            <secteur-tag-input v-model="secteursSelected"
              :label="$t('detailsPlanningFaceUnitaire.filtre.secteur')"
              :critere="(el) => el.type === constantes.COMMERCIAL"
              :disabled="secteurCurrentUser.length > 0">
            </secteur-tag-input>
          </div>
        </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('detailsPlanningFaceUnitaire.filtre.actions.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pdl-10px"
        @click="viderCritere()"
      >{{$t('detailsPlanningFaceUnitaire.filtre.actions.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { SET_CRITERES_RECHERCHE_PLANNING } from '@/store/modules/produitFace-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import secteurTagInput from '@/components/commun/secteur/secteurTagInput';
import { COMMERCIAL } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser from '@/services/commun/secteur/getSecteurs';
import { genererCritereRecherchePlanningProduitFace }
  from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitFace';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const productsFaceUnitaire = createNamespacedHelpers('produitFace');

export default {
  components: {
    VilleTagInputAutoComplete,
    secteurTagInput,
  },
  data() {
    return {
      critereRecherche: null,
      constantes: {
        COMMERCIAL,
      },
      secteursSelected: [],
      secteurCurrentUser: [],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    ...productsFaceUnitaire.mapGetters({
      critereRechercheFromStore: 'critereRecherchePlanning',
    }),
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    secteurs() {
      return this.parametre(PARAMETRES_KEYS.secteur);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    ...productsFaceUnitaire.mapMutations({
      setCritereRecherche: SET_CRITERES_RECHERCHE_PLANNING,
    }),
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRecherchePlanningProduitFace());
      if (this.moduleSecteurActive) {
        this.secteursSelected = this.secteurCurrentUser ?? [];
      }
    },
    appliquerCritere() {
      if (this.moduleSecteurActive) {
        this.critereRecherche.secteurIds = this.secteursSelected.map(s => s.id);
      }
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
          PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
          PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
        ]);
        this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
        if (this.moduleSecteurActive) {
          await this.loadParametres([PARAMETRES_KEYS.secteur]);
          this.secteurCurrentUser = await getSecteursIdByUser(COMMERCIAL, true);
          if (this.critereRecherche.secteurIds.length > 0) {
            this.secteursSelected = this.secteurs.filter((s) => {
              return this.critereRecherche.secteurIds.includes(s.id) && s.actif === true;
            });
          }
          if (this.secteurCurrentUser?.length > 0) {
            this.secteursSelected = this.secteurCurrentUser;
          }
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
